import { useQuery } from '@tanstack/react-query'
import type { QueryClient } from '@tanstack/react-query'
import { getWorkflowOrderConfirmationSettings } from '@/services/api'
import type { Workflow } from '@/types/workflow'

export const workflowOrderConfirmationSettingsQueryKey = (workflowId: string) =>
  ['workflow-order-confirmation-settings', workflowId] as const

/** Cached for the session; settings change rarely and are prefetched after login. */
export const workflowOrderConfirmationSettingsQueryOptions = {
  staleTime: 5 * 60 * 1000,
} as const

export function prefetchWorkflowOrderConfirmationSettings(
  queryClient: QueryClient,
  workflows: Workflow[],
): void {
  for (const workflow of workflows) {
    if (workflow.type !== 'oc') continue
    void queryClient.prefetchQuery({
      queryKey: workflowOrderConfirmationSettingsQueryKey(workflow.id),
      queryFn: () => getWorkflowOrderConfirmationSettings(workflow.id),
      ...workflowOrderConfirmationSettingsQueryOptions,
    })
  }
}

export function useWorkflowOrderConfirmationSettings(workflowId: string | undefined) {
  return useQuery({
    queryKey: workflowOrderConfirmationSettingsQueryKey(workflowId ?? ''),
    queryFn: () => getWorkflowOrderConfirmationSettings(workflowId!),
    enabled: !!workflowId,
    ...workflowOrderConfirmationSettingsQueryOptions,
  })
}
